module.exports = __webpack_public_path__ + "img/gw-checkout.c51b1658.png";